import { Popover } from "devextreme-react/popover";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { v4 as uuid } from "uuid";
export default function Menu(props) {
    const [open, setOpen] = useState(false);
    const id = useMemo(() => `menuToggler_${uuid()}`, []);
    useEffect(() => {
        props.onInitialized && props.onInitialized();
    }, []);
    const wrapperAttr = useMemo(() => ({
        class: "popover-as-dropdown",
        zIndex: props.zIndex
    }), [props.zIndex]);
    const handleTogglerClick = useCallback(() => {
        setOpen(prev => !prev);
    }, []);
    const handleHidden = useCallback(() => {
        props.onHidden && props.onHidden();
        setOpen(false);
    }, []);
    const handleContentClick = useCallback((e) => {
        e && setOpen(false);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(props.menuToggler, { id: id, className: props.className, isOpen: props.menuItems.length ? open : false, onClick: handleTogglerClick }),
        React.createElement(Popover, { animation: undefined, wrapperAttr: wrapperAttr, target: `#${id}`, container: props.container, position: props.position, visible: open, onHidden: handleHidden, hideOnParentScroll: true, hideOnOutsideClick: true, deferRendering: false, minWidth: props.menuMinWidth, maxWidth: props.menuMaxWidth },
            React.createElement("div", { role: "none", className: "popover-content p-0", onClick: handleContentClick },
                React.createElement("ul", { className: "dropdown-menu" }, props.menuItems)))));
}
Menu.defaultProps = {
    menuMinWidth: 200,
    menuMaxWidth: 350,
    container: document.body,
    position: {
        my: "top right",
        at: "bottom right",
        collision: "fit flip",
        offset: { y: 4 }
    }
};
